import React, { useEffect, useState } from "react";
import "./stylesheets/servicereportpreview.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  getBackSiteid,
  getGeneratedListPreview,
  getInvoicedListPreview,
  getPickListPreview,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import { MdOutlinePreview } from "react-icons/md";
import Moment from "moment";
import { FaArrowCircleUp } from "react-icons/fa";
import {
  Button,
  Dropdown,
  Offcanvas,
  FloatingLabel,
  Form,
  Table,
  Modal,
} from "react-bootstrap";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useParams } from "react-router-dom";

const ServiceReportPreview = ({ match }) => {
  const [visible, setVisible] = useState(false);
  const [lodingImagData, setLodingImagData] = useState(false);
  const [listSiteId, setListSiteId] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [siteId, setSiteId] = useState("");
  const [editBtn, setEditBtn] = useState(false);
  const [pickListPreviewData, setPickListPreviewData] = useState("");
  const [generatedListPreviewData, setGeneratedListPreviewData] = useState("");
  const [invoicedListPreviewData, setInvoicedListPreviewData] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [showIframe, setShowIframe] = useState(false);
  // const [loadingImg, setLoadingImg] = useState(false);

  const { id } = useParams();
  const showKey = localStorage.getItem("service_report_id");

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", toggleVisible);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    var ApplicationTenantID = readDataSelected.ApplicationTenantID;
    var sendDataSite = {
      userid: userId,
      applicationtenantId: ApplicationTenantID,
    };

    const fetchSiteId = async () => {
      const responsesites = await getBackSiteid(sendDataSite);
      const datarespsites = await responsesites;
      var siteIdArr = [];
      for (var i = 0; i < datarespsites.length; i++) {
        var siteId = {};
        siteId.key = datarespsites[i].SiteID;
        siteId.value = datarespsites[i].SiteName;
        siteIdArr.push(siteId);
      }
      setListSiteId(siteIdArr);
      setSelectedSite(siteIdArr[0].value);
      setSiteId(siteIdArr[0].key);
      setEditBtn(editBtn);
    };

    const fetchPickListData = async () => {
      var sendData = {
        id: id,
      };
      const responsesites = await getPickListPreview(sendData);
      const datarespsites = await responsesites;
      setPickListPreviewData(datarespsites);
    };

    const fetchGeneratedListData = async () => {
      var sendData = {
        id: id,
      };
      const responsesites = await getGeneratedListPreview(sendData);
      const datarespsites = await responsesites;
      setGeneratedListPreviewData(datarespsites);
    };

    const fetchInvoicedListData = async () => {
      var sendData = {
        id: id,
      };
      const responsesites = await getInvoicedListPreview(sendData);
      const datarespsites = await responsesites;
      setInvoicedListPreviewData(datarespsites);
    };

    fetchSiteId();
    if (showKey === "PickList") {
      fetchPickListData();
    } else if (showKey === "Generated") {
      fetchGeneratedListData();
    } else if (showKey === "Invoice") {
      fetchInvoicedListData();
    } else {
      fetchGeneratedListData();
    }

    return () => {
      window.removeEventListener("scroll", toggleVisible);
    };
  }, []);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleImageDownload = async (selected, DocumentID) => {
    var ApplicationTenantID = 0;
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    if (
      accessselectedtentant !== "" &&
      accessselectedtentant !== null &&
      accessselectedtentant !== undefined
    ) {
      const readDataSelected = JSON.parse(accessselectedtentant);
      ApplicationTenantID = readDataSelected.ApplicationTenantID;
    }
    const token = JSON.parse(localStorage.getItem("auth"));

    if (DocumentID !== "" && DocumentID !== null && DocumentID !== undefined) {
      var url =
        process.env.REACT_APP_API_URL +
        "documents/" +
        DocumentID +
        "/?application_tenant_id=" +
        ApplicationTenantID;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const blob = await res.blob();
      var urlObject = URL.createObjectURL(blob);
      // Setting various property values
      // let alink = document.createElement("a");
      // alink.href = urlObject;
      // alink.download = selected;
      // alink.click();
      setFileUrl(urlObject);
      setShowIframe(true);
    }
  };

  const loadingImg = require("../../../assets/images/Hourglass.gif");
  const viewFile = require("../../../assets/images/BG User Manual_V1.0 1 (1).pdf");
  const viewImage = require("../../../assets/images/Background.JPG");

  var SRData = [];
  var newelement = {
    Job: [],
    Work: "Pulley Lagging",
    Measurements:
      "Length (mm): 22, Width (mm): 56, Thickness (mm): 67, Face Length (mm): 76, Dia (mm): 20",
    Dept: "MECHANICAL",
    ConvRef: "5",
    Date: "30-Oct-2023 09:00 AM-30-Oct-2023 12:45 PM - 225 Min",
    WorkOther: "Pulley Lagging",
    MeasurementsOther:
      "Length (mm): 22, Width (mm): 56, Thickness (mm): 67, Face Length (mm): 76, Dia (mm): 20",
    DeptOther: "MECHANICAL",
    ConvRefOther: "5",
    DateOther: "30-Oct-2023 09:00 AM-30-Oct-2023 12:45 PM - 225 Min",
    SRDate: "23-Oct-2023",
    CustomerName: "Larsen & Toubro Limited Chennai",
    By: "Rajesh",
  };
  SRData.push(newelement);

  console.log(generatedListPreviewData);

  return (
    <div>
      {/* <HeaderBack /> */}
      {showKey === "PickList" ? (
        <div className=" mx-5">
          {" "}
          <div className="rowUser mt-5 ">
            <div className="col-md-12 form-group input-user">
              <Table responsive className="tableReport">
                <thead className="header-border">
                  {/* <th>Sr #<span className="required"> </span></th> */}
                  <th className="taskWith alginCenter">PL #</th>
                  <th className="alginCenter">PL Date</th>
                  <th className="alginCenter">Customer</th>
                  <th className="alginCenter">PL Generated By</th>
                  <th className="alginCenter">PL Generated On</th>
                </thead>
                <tbody>
                  <tr key={pickListPreviewData?.PICKID}>
                    <td className="alginCenter">
                      {pickListPreviewData?.PICKID}
                    </td>
                    <td className="alginCenter">
                      {Moment(pickListPreviewData?.ModifiedDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </td>
                    <td className="alginCenter">
                      {pickListPreviewData?.CustomerName}
                    </td>
                    <td className="alginCenter">
                      {pickListPreviewData?.ModifiedBy}
                    </td>
                    <td className="alginCenter">
                      {Moment(pickListPreviewData?.ModifiedDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>{" "}
          <div className="rowUser mt-1 ">
            <div className="col-md-12 form-group input-user">
              <Table bordered responsive className="tableAdd">
                <thead>
                  {/* <th>Sr #<span className="required"> *</span></th> */}
                  <th className=" alginCenter colorHeader">
                    Job #<span className="required">*</span>
                  </th>
                  <th className="alginCenter colorHeader">
                    Actual Job Details
                  </th>
                  <th className="alginCenter colorHeader">SR Job Details</th>

                  {/* <th className="alginCenter colorHeader">Action</th> */}
                </thead>
                <tbody>
                  {pickListPreviewData?.JobInfo?.map((item, indexle) => {
                    return (
                      <tr
                        className={`${item?.deleted ? "rowDisabled" : ""} `}
                        key={indexle}
                      >
                        <td className="tableFontSize jobNumberWidth alginCenter">
                          {item?.JobID}
                        </td>
                        <td className="tableFontSize alginCenter">
                          {item?.ActualJobDetails}
                        </td>

                        <td className="tableFontSize alginCenter">
                          {/* <textarea
                          type="text"
                          className="form-control noBorder srJobDetailWidth"
                          required={true}
                          value={item?.SRJobDetails || ""} // Set initial value
                          onChange={(e) =>
                            this.handleInputSRDetailChange(
                              indexle,
                              e.target.value
                            )
                          } // Handle change event
                          disabled={item?.deleted}
                          name="Work"
                          placeholder="Enter Job detail"
                        /> */}{" "}
                          {item?.SRJobDetails}
                        </td>

                        {/* <td className="alginCenter">
                        <span
                          className="saveBtnUsMi cursorPoint"
                          onClick={() => this.handleDataRemoveDetails(indexle)}
                          disabled={item?.deleted}
                        >
                          <FaMinusCircle className="btnClassMinus" />
                        </span>
                      </td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>{" "}
        </div>
      ) : (
        ""
      )}

      {showKey === "Generated" ? (
        <div className=" mx-5">
          {" "}
          <div className="rowUser mt-5">
            <div className="col-md-12 form-group input-user">
              <Table responsive className="tableReport">
                <thead className="header-border">
                  {/* <th>Sr #<span className="required"> </span></th> */}
                  <th className="taskWith alginCenter">SR #</th>
                  <th className="alginCenter">SR Date</th>
                  <th className="alginCenter">Customer</th>
                  <th className="alginCenter">SR Generated By</th>
                  <th className="alginCenter">SR Generated On</th>
                </thead>
                <tbody>
                  <tr key={generatedListPreviewData?.SRID}>
                    <td className="alginCenter">
                      {generatedListPreviewData?.SRID}
                    </td>
                    <td className="alginCenter">
                      {Moment(generatedListPreviewData?.SRDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </td>
                    <td className="alginCenter">
                      {generatedListPreviewData?.CustomerName}
                    </td>
                    <td className="alginCenter">
                      {generatedListPreviewData?.ModifiedBy}
                    </td>
                    <td className="alginCenter">
                      {Moment(generatedListPreviewData?.SRDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>{" "}
          <div className="rowUser mt-1 ">
            <div className="col-md-12 form-group input-user">
              <Table bordered responsive className="tableAdd">
                <thead>
                  {/* <th>Sr #<span className="required"> *</span></th> */}
                  <th className=" alginCenter colorHeader">
                    Job #<span className="required">*</span>
                  </th>
                  <th className="alginCenter colorHeader">
                    Actual Job Details
                  </th>
                  <th className="alginCenter colorHeader">SR Job Details</th>

                  {/* <th className="alginCenter colorHeader">Action</th> */}
                </thead>
                <tbody>
                  {generatedListPreviewData?.SRJobsDetail?.map(
                    (item, indexle) => {
                      return (
                        <tr
                          className={`${item?.deleted ? "rowDisabled" : ""} `}
                          key={indexle}
                        >
                          <td className="tableFontSize alginCenter">
                            {item?.JobID}
                          </td>
                          <td className="tableFontSize alginCenter">
                            {item?.ActualJobDetails}
                          </td>

                          <td className="tableFontSize alginCenter">
                            {item?.SRJobDetails}
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          <div className="rowUser mt-1 ">
            <div className="col-md-12 form-group input-user">
              <Table bordered responsive className="tableAdd">
                <thead>
                  <th className="alginCenter colorHeader">Document Name</th>
                  <th className="alginCenter colorHeader">Description</th>
                  <th className="alginCenter colorHeader">Uploaded By/On</th>
                  <th className="alginCenter colorHeader">Action</th>
                </thead>
                <tbody>
                  {generatedListPreviewData?.SRDocuments?.map(
                    (item, indexle) => {
                      return (
                        <tr
                          className={`${item?.deleted ? "rowDisabled" : ""} `}
                          key={indexle}
                        >
                          <td className="tableFontSize alginCenter">
                            {item?.FileName}
                          </td>
                          <td className="tableFontSize wrapDescription alginCenter">
                            {item?.Description}
                          </td>

                          <td className="tableFontSize alginCenter">
                            {item?.UploadedBy} /{" "}
                            {Moment(item?.UploadedOn).format("DD-MMM-YYYY")}
                          </td>

                          <td className="alginCenter">
                            <span
                              className="saveBtnUsMi cursorPoint"
                              disabled={item?.deleted}
                            >
                              <MdOutlinePreview
                                size={20}
                                title="Preview"
                                onClick={() =>
                                  handleImageDownload(
                                    item.FileName,
                                    item.DocumentID
                                  )
                                }
                              />
                            </span>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          {showIframe && (
            <div className="ViewFile mt-4">
              <iframe src={fileUrl} className="mainImage" height="550"></iframe>
            </div>
          )}{" "}
        </div>
      ) : (
        ""
      )}

      {showKey === "Signed" ? (
        <div className=" mx-5">
          {" "}
          <div className="rowUser mt-5 ">
            <div className="col-md-12 form-group input-user">
              <Table responsive className="tableReport">
                <thead className="header-border">
                  {/* <th>Sr #<span className="required"> </span></th> */}
                  <th className="taskWith alginCenter">SR #</th>
                  <th className="alginCenter">SR Date</th>
                  <th className="alginCenter">Customer</th>
                  <th className="alginCenter">Signed Date</th>
                  <th className="alginCenter">SR Generated By</th>
                  <th className="alginCenter">SR Generated On</th>
                </thead>
                <tbody>
                  <tr key={generatedListPreviewData?.SRID}>
                    <td className="alginCenter">
                      {generatedListPreviewData?.SRID}
                    </td>
                    <td className="alginCenter">
                      {Moment(generatedListPreviewData?.ModifiedDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </td>
                    <td className="alginCenter">
                      {generatedListPreviewData?.CustomerName}
                    </td>
                    <td className="alginCenter">
                      {Moment(generatedListPreviewData?.SRSignedDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </td>
                    <td className="alginCenter">
                      {generatedListPreviewData?.ModifiedBy}
                    </td>
                    <td className="alginCenter">
                      {Moment(generatedListPreviewData?.ModifiedDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>{" "}
          <div className="rowUser mt-1 ">
            <div className="col-md-12 form-group input-user">
              <Table bordered responsive className="tableAdd">
                <thead>
                  {/* <th>Sr #<span className="required"> *</span></th> */}
                  <th className=" alginCenter colorHeader">
                    Job #<span className="required">*</span>
                  </th>
                  <th className="alginCenter colorHeader">
                    Actual Job Details
                  </th>
                  <th className="alginCenter colorHeader">SR Job Details</th>

                  {/* <th className="alginCenter colorHeader">Action</th> */}
                </thead>
                <tbody>
                  {generatedListPreviewData?.SRJobsDetail?.map(
                    (item, indexle) => {
                      return (
                        <tr
                          className={`${item?.deleted ? "rowDisabled" : ""} `}
                          key={indexle}
                        >
                          <td className="tableFontSize alginCenter">
                            {item?.JobID}
                          </td>
                          <td className="tableFontSize alginCenter">
                            {item?.ActualJobDetails}
                          </td>

                          <td className="tableFontSize alginCenter">
                            {item?.SRJobDetails}
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          <div className="rowUser mt-1 ">
            <div className="col-md-12 form-group input-user">
              <Table bordered responsive className="tableAdd">
                <thead>
                  <th className="alginCenter colorHeader">Document Name</th>
                  <th className="alginCenter colorHeader">Description</th>
                  <th className="alginCenter colorHeader">Uploaded By/On</th>
                  <th className="alginCenter colorHeader">Action</th>
                </thead>
                <tbody>
                  {generatedListPreviewData?.SRDocuments?.map(
                    (item, indexle) => {
                      return (
                        <tr
                          className={`${item?.deleted ? "rowDisabled" : ""} `}
                          key={indexle}
                        >
                          <td className="tableFontSize alginCenter">
                            {item?.FileName}
                          </td>
                          <td className="tableFontSize wrapDescription alginCenter">
                            {item?.Description}
                          </td>

                          <td className="tableFontSize alginCenter">
                            {item?.UploadedBy} /{" "}
                            {Moment(item?.UploadedOn).format("DD-MMM-YYYY")}
                          </td>

                          <td className="alginCenter">
                            <span
                              className="saveBtnUsMi cursorPoint"
                              disabled={item?.deleted}
                            >
                              <MdOutlinePreview
                                size={20}
                                title="Preview"
                                onClick={() =>
                                  handleImageDownload(
                                    item.FileName,
                                    item.DocumentID
                                  )
                                }
                              />
                            </span>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          {showIframe && (
            <div className="ViewFile mt-4">
              <iframe src={fileUrl} className="mainImage" height="550"></iframe>
            </div>
          )}{" "}
        </div>
      ) : (
        ""
      )}

      {showKey === "Invoice" ? (
        <div className=" mx-5">
          {" "}
          <div className="rowUser mt-5 ">
            <div className="col-md-12 form-group input-user">
              <Table responsive className="tableReport">
                <thead className="header-border">
                  {/* <th>Sr #<span className="required"> </span></th> */}
                  <th className="taskWith alginCenter">Invoice #</th>
                  <th className="alginCenter">Date</th>

                  <th className="alginCenter">Updated By</th>
                  <th className="alginCenter">Updated On</th>
                </thead>
                <tbody>
                  <tr key={invoicedListPreviewData?.InvoiceID}>
                    <td className="alginCenter">
                      {invoicedListPreviewData?.InvoiceID}
                    </td>
                    <td className="alginCenter">
                      {Moment(invoicedListPreviewData?.InvoiceDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </td>
                    <td className="alginCenter">
                      {invoicedListPreviewData?.ModifiedBy}
                    </td>
                    <td className="alginCenter">
                      {Moment(invoicedListPreviewData?.ModifiedDate).format(
                        "DD-MMM-YYYY"
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>{" "}
          <div className="rowUser mt-2 ">
            <div className="col-md-12 form-group input-user">
              <Table bordered responsive className="tableReport">
                <thead className="header-border">
                  {/* <th>Sr #<span className="required"> </span></th> */}
                  <th className="taskWith alginCenter">SR #</th>
                  <th className="alginCenter">SR Date</th>
                  <th className="alginCenter">Customer</th>
                  <th className="alginCenter">Signed Date</th>
                  <th className="alginCenter">SR Generated By</th>
                  <th className="alginCenter">SR Generated On</th>
                </thead>
                <tbody>
                  {invoicedListPreviewData?.SrDetails?.map((item, indexle) => {
                    return (
                      <tr key={item?.SRID}>
                        <td className="alginCenter">{item?.SRID}</td>
                        <td className="alginCenter">
                          {Moment(item?.ModifiedDate).format("DD-MMM-YYYY")}
                        </td>
                        <td className="alginCenter">{item?.CustomerName}</td>
                        <td className="alginCenter">
                          {Moment(item?.SRSignedDate).format("DD-MMM-YYYY")}
                        </td>
                        <td className="alginCenter">{item?.ModifiedBy}</td>
                        <td className="alginCenter">
                          {Moment(item?.ModifiedDate).format("DD-MMM-YYYY")}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>{" "}
          <div className="rowUser mt-1 ">
            <div className="col-md-12 form-group input-user">
              <Table bordered responsive className="tableAdd">
                <thead>
                  {/* <th>Sr #<span className="required"> *</span></th> */}
                  <th className=" alginCenter colorHeader">
                    Job #<span className="required">*</span>
                  </th>
                  <th className="alginCenter colorHeader">
                    Actual Job Details
                  </th>
                  <th className="alginCenter colorHeader">SR Job Details</th>

                  {/* <th className="alginCenter colorHeader">Action</th> */}
                </thead>
                <tbody>
                  {invoicedListPreviewData?.SRJobsDetail?.map(
                    (item, indexle) => {
                      return (
                        <tr
                          className={`${item?.deleted ? "rowDisabled" : ""} `}
                          key={indexle}
                        >
                          <td className="tableFontSize alginCenter">
                            {item?.JobID}
                          </td>
                          <td className="tableFontSize alginCenter">
                            {item?.ActualJobDetails}
                          </td>

                          <td className="tableFontSize alginCenter">
                            {item?.SRJobDetails}
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          <div className="rowUser mt-1 ">
            <div className="col-md-12 form-group input-user">
              <Table bordered responsive className="tableAdd">
                <thead>
                  <th className="alginCenter colorHeader">Document Name</th>
                  <th className="alginCenter colorHeader">Description</th>
                  <th className="alginCenter colorHeader">Uploaded By/On</th>
                  <th className="alginCenter colorHeader">Action</th>
                </thead>
                <tbody>
                  {invoicedListPreviewData?.SRDocuments?.map(
                    (item, indexle) => {
                      return (
                        <tr
                          className={`${item?.deleted ? "rowDisabled" : ""} `}
                          key={indexle}
                        >
                          <td className="tableFontSize alginCenter">
                            {item?.FileName}
                          </td>
                          <td className="tableFontSize wrapDescription alginCenter">
                            {item?.Description}
                          </td>

                          <td className="tableFontSize alginCenter">
                            {item?.UploadedBy} /{" "}
                            {Moment(item?.UploadedOn).format("DD-MMM-YYYY")}
                          </td>

                          <td className="alginCenter">
                            <span
                              className="saveBtnUsMi cursorPoint"
                              disabled={item?.deleted}
                            >
                              <MdOutlinePreview
                                size={20}
                                title="Preview"
                                onClick={() =>
                                  handleImageDownload(
                                    item.FileName,
                                    item.DocumentID
                                  )
                                }
                              />
                            </span>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          {showIframe && (
            <div className="ViewFile mt-4">
              <iframe src={fileUrl} className="mainImage" height="550"></iframe>
            </div>
          )}{" "}
        </div>
      ) : (
        ""
      )}

      {/* <div className="ViewFile TransformWrapper mt-4 mb-6">
        <TransformWrapper>
          <TransformComponent contentClass="">
            <img
              src={viewImage}
              alt="Image"
              className="cursorPoint"
              height="550"
            />
          </TransformComponent>
        </TransformWrapper>
      </div> */}
      <div className="scrollClass">
        <FaArrowCircleUp
          onClick={scrollToTop}
          style={{ display: visible ? "inline" : "none" }}
        />
      </div>
      {lodingImagData && (
        <span className="preloader">
          <img src={loadingImg} className="loaderImg" />
        </span>
      )}
    </div>
  );
};

export default ServiceReportPreview;
